import { computed, makeObservable } from 'mobx'

import { Model } from 'modules/core/lib/mobx-rest'

import templateWeeks from 'modules/shift_management/store/api/collections/templateWeeks'
import type TemplateWeek from 'modules/shift_management/store/api/models/TemplateWeek'

interface IShiftTemplate {
  id: number
  name: string
  company_id: number
  schedule_type: string
  archived: boolean
}

// TODO: Deprecate when create/edit are migrated to GraphQL, we have only migrated the index (https://github.com/factorialco/factorial/pull/52951)
class ShiftTemplate extends Model<IShiftTemplate> {
  constructor(attr: IShiftTemplate) {
    super(attr)
    makeObservable(this, {
      weeks: computed,
      isActive: computed,
      activeWeeks: computed,
    })
  }

  static urlRoot() {
    return '/shift_management/templates'
  }

  get weeks(): TemplateWeek[] {
    return templateWeeks.filter({
      template_id: this.attributes.id,
    })
  }

  get activeWeeks(): TemplateWeek[] {
    return this.weeks.filter((week) => week.isActive)
  }

  get isActive(): boolean {
    return !this.attributes.archived
  }
}

export default ShiftTemplate
